module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_7016.e5fa67d1.png";